app.service('DomainsContractApiService', ['$rootScope', '$window', '$stateParams', 'crudService', 'utilsService', function ($rootScope, $window, $stateParams, crudService, utilsService) {
    this.contract_id = $stateParams.contrat_id || null;

    if (!this.contract_id) {
        throw new Error("[ERR] DomainsContractApiService - contract id must be defined !");
    }

    this.baseUri = '/contrat_cadre/:contract_id/domains';

    this.all = function () {
        return crudService.get(this.getUri('/'));
    };

    this.getUri = function (str, data) {
        str = str || '';
        data = data || {};
        if (Object.keys(data).length) {
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    str = str.replace(':' + key, data[key]);
                }
            }
        }
        return this.baseUri.replace(':contract_id', this.contract_id) + str;
    };

    this._setUrlParams = function (url, searchParams) {
        if ($window.URLSearchParams && angular.isDefined(searchParams) && Object.keys(searchParams).length) {
            var urlParams = new $window.URLSearchParams($window.location.search);
            for (var key in searchParams) {
                if (searchParams.hasOwnProperty(key) && searchParams[key] !== null && utilsService.isNotEmpty(searchParams[key])) {
                    if (!urlParams.has(key)) {
                        urlParams.append(key, searchParams[key]);
                    }
                }
            }
            if (urlParams.toString().length) {
                url += '?' + urlParams.toString();
            }
        }
        return url;
    };

}]);
